<template>
  <div class="col-12" style="height:100%;overflow:scroll;">
    <card id="order-med-card" class="mt-2" style="border-radius: 24px" card-body-classes="pt-0" v-for="training in trainings" :key="training._id" :style="{ 'background-color': training.backgroundColor || 'var(--color-primary)' }" @click.native="goToYogaSchedule(training)">
      <h5 slot="header" class="card-title" style="font-weight: 500;color: #fff;font-weight: 600;">
        {{ training.title }}
      </h5>
      <div class="pb-3" style="color: #fff">
        {{ training.description }}
      </div>
      <dynamic-image v-if="training.image" :file-id="training.image" image-style="position: absolute;
            height: 100%;
            top: 0px;
            inset-inline-end: 0px;padding: 0.5rem;border-radius: 24px;">
      </dynamic-image>
    </card>
  </div>
</template>

<script>
export default {
  name: "videos",

  components: {},

  created() {
    if (this.caregroup.videos && this.caregroup.videos.length > 0) {
      this.selectedVideo = this.caregroup.videos[0];
    }
  },

  data() {
    return {
      trainings: [],
      LOADING: true,
      selectedVideo: null,
      playerVars: {
        autoplay: 1,
        modestbranding: 1,
      },
    };
  },

  async mounted() {
    this.$root.onBackButton = () => {
      let featureEnabled = []
      for (let option in this.settings.patientWellness.yoga) {
        if (this.settings.patientWellness.yoga[option].enabled) {
          featureEnabled.push(option)
        }
      }
      if (featureEnabled.length == 1) {
        this.$router.push("/patienthome");
      }
      else {
        this.$router.push('yogavideos')
      }

    };
    let that = this;
    try {
      this.trainings = (await this.$store.dispatch("getYogaTrainings")).data;
      that.LOADING = false;
    } catch (error) {
      that.LOADING = false;
      console.log(error);
    }
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
  },

  computed: {
    user() {
      return JSON.parse(localStorage.user);
    },
    caregroup() {
      return this.$store.state.caregroup;
    },
    player() {
      return this.$refs.youtube.player;
    },
  },
  methods: {
    selectVideo(video) {
      this.selectedVideo = video;
      this.$forceUpdate();
    },
    /*    goToTraining(training) {
      this.$store.commit("setState", {
        stateName: "training",
        stateValue: training,
      });
      this.$router.push("/training");
    }, */
    goToYogaSchedule(training) {
      this.$store.commit("setState", {
        stateName: "training",
        stateValue: training,
      });
      this.$router.push("/yogaschedule");
    },
  },
};
</script>

<style scoped>
#order-med-card {
  background-size: cover;
  background-repeat: no-repeat;
}

/deep/ iframe {
  width: 100%;
  height: 16em;
}

.video-thumbnail {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.playing-video-title {
  font-weight: 600;
  margin-top: 1rem;
}

.videos-list {
  overflow-y: scroll;
  height: 54vh;
}

/deep/.el-loading-spinner {
  position: fixed;
}

/deep/ .el-loading-mask {
  background: #fff !important;
}

@media (min-width: 992px) {
  iframe {
    height: 31em;
  }
}

@media (min-height: 736px) {
  /deep/ iframe {
    height: 35vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 768px) {
  /deep/ iframe {
    height: 40vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 1024px) {
  iframe {
    height: 31em;
  }

  .videos-list {
    height: 46vh;
  }
}
</style>
